import React, { useCallback, useEffect, useState, useMemo } from "react";
import classNames from 'classnames';
import Tooltip from "@mui/material/Tooltip";

import styles from './styles.module.scss';
import { httpGet } from "../../httpCall";
import LoadingComponent from "modules/primitives/loading/loading.component";
import { Icon, mdSize } from "../../icon";

const tooltipTextsByState = {
  different_solution: 'Different Solution in Place',
  under_review: 'Possible Replication',
  not_applicable: 'Not Applicable for this Plant'
}

const PossibleReplicationsFordModal = ({ data, formikProps }) => {
  const [replicationsData, setReplicationsData] = useState(null);

  useEffect(() => {
    httpGet({
      call: `possible_replications/plants_and_areas?resource_id=${data.id}&resource_type=Idea`
    }).subscribe(res => {
      setReplicationsData(res.response || []);
      formikProps.setFieldValue("possible_replications", res.response);
    });
  }, []);

  const makeReplicationsData = useMemo(() => {
    return replicationsData?.filter(obj => !(obj.current_user_plant && !obj.state) && !obj.discarded_at)
  }, [replicationsData]);

  const handleDeletePlant = useCallback((plant) => {
    const newReplications = replicationsData.filter(p => p.id !== plant.id);

    formikProps.setFieldValue("possible_replications", newReplications);
    setReplicationsData(newReplications);
  }, [replicationsData, formikProps])

  return (
    <div className={`d-flex flex-column ${styles.possibleReplications}`}>
      <hr className="mb-3" />
      <span className="mb-3">Possible Replications</span>
      {
        makeReplicationsData?.length > 0 ? (
          <>
            {
              makeReplicationsData.map(obj => (
                <div key={obj.id} className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <div className="col-7 d-flex flex-column text-center pl-0">
                      <span className="text-left small">Plant</span>
                      <span className="text-left small">{obj.name}</span>
                    </div>
                    <div className="col-3 d-flex flex-column align-items-end pr-0">
                      <span className="small">Status</span>
                      <Tooltip
                        title={tooltipTextsByState[obj.state]}
                        placement="top"
                      >
                        <div className={classNames(styles.plantCircle, styles[obj.state])}></div>
                      </Tooltip>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                      <Icon
                        {...mdSize}
                        icon="icn-button-delete"
                        className="cursor-pointer"
                        onClick={() => handleDeletePlant(obj)}
                      />
                    </div>
                  </div>
                  {
                    makeReplicationsData.length > 1 ? (
                      <hr className="mt-3 mb-3" />
                    ) : null
                  }
                </div>
              ))
            }
          </>
        ) : !makeReplicationsData ? (
          <LoadingComponent customText="Getting replications..." />
        ) : 'No replications'
      }
    </div>
  )
};

export default PossibleReplicationsFordModal;
